import { toast } from "sonner";
import { MessageCircle, Facebook, Send, Link2, Share2 } from "lucide-react";
import { traccia } from "@/lib/tracking";

export const URL_SITO = "https://interventoidraulicoh24.com/";

export const ShareButtons = ({ testo, idPrefix = "share" }) => {
  const url = URL_SITO;
  const msg = `${testo} ${url}`;
  const log = (canale) => traccia("condivisione", { canale, posizione: idPrefix });
  const nativo = async () => {
    log("nativo");
    try { await navigator.share({ title: "Interventi Idraulici Andrea Morelli", text: testo, url }); } catch { /* annullato */ }
  };
  const copia = () => navigator.clipboard.writeText(url).then(() => { log("copia"); toast.success("Link copiato: incollalo dove vuoi"); });
  const btn = "h-11 inline-flex items-center justify-center gap-2 rounded-full px-4 text-sm font-bold transition-colors";

  return (
    <div className="flex flex-wrap gap-2" data-testid={`${idPrefix}-buttons`}>
      {typeof navigator !== "undefined" && navigator.share && (
        <button onClick={nativo} className={`${btn} bg-slate-900 text-white hover:bg-slate-800`} data-testid={`${idPrefix}-native-btn`}><Share2 className="w-4 h-4" /> Condividi</button>
      )}
      <a href={`https://api.whatsapp.com/send?text=${encodeURIComponent(msg)}`} target="_blank" rel="noreferrer" onClick={() => log("whatsapp")} className={`${btn} bg-green-600 text-white hover:bg-green-700`} data-testid={`${idPrefix}-whatsapp-btn`}><MessageCircle className="w-4 h-4" /> WhatsApp</a>
      <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer" onClick={() => log("facebook")} className={`${btn} bg-[#1877F2] text-white hover:opacity-90`} data-testid={`${idPrefix}-facebook-btn`}><Facebook className="w-4 h-4" /> Facebook</a>
      <a href={`https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(testo)}`} target="_blank" rel="noreferrer" onClick={() => log("telegram")} className={`${btn} bg-sky-500 text-white hover:bg-sky-600`} data-testid={`${idPrefix}-telegram-btn`}><Send className="w-4 h-4" /> Telegram</a>
      <button onClick={copia} className={`${btn} bg-white border border-slate-300 hover:bg-slate-50`} data-testid={`${idPrefix}-copy-btn`}><Link2 className="w-4 h-4" /> Copia link</button>
    </div>
  );
};
